var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "history-container" },
    [
      _c(
        "el-card",
        { staticClass: "header-container" },
        [
          _c(
            "el-row",
            {
              staticStyle: { height: "50px" },
              attrs: { align: "middle", type: "flex", gutter: 5 },
            },
            [
              _c("i", {
                staticClass: "el-icon-back",
                on: { click: _vm.handleBack },
              }),
              _c("img", {
                staticClass: "header-logo",
                attrs: { src: require("@/assets/images/logo-blue.png") },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ path: "/home" })
                  },
                },
              }),
              _vm.detailInfo
                ? _c("div", { staticClass: "publish_info" }, [
                    _c("span", [
                      _vm._v("第" + _vm._s(_vm.detailInfo.no) + "次发布 | "),
                    ]),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.detailInfo.inUse
                              ? _vm.detailInfo.createTime + " 至今 "
                              : _vm.detailInfo.createTime +
                                  " 至 " +
                                  _vm.detailInfo.updateTime
                          ) +
                          " "
                      ),
                    ]),
                    _c("span", [
                      _vm._v(" | " + _vm._s(_vm.detailInfo.publisher)),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content-container" },
        [
          _c("pre-view", {
            attrs: { detailUrl: "/user/form/release/id/" + _vm.detailInfo.id },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }